import { autoUpdate, offset, shift, useFloating } from '@floating-ui/react-dom';

export const useSetupLinkPopupFloating = (floating, reference) => {
  return useFloating({
    elements: {
      floating,
      reference,
    },
    placement: 'bottom',
    middleware: [offset(4), shift()],
    whileElementsMounted: autoUpdate,
  });
};
